import instanceQuery from 'graphql/queries/supplier/SupplierConfigQuery.graphql';
import defaultQuery from 'graphql/queries/supplier/SupplierConfigDefault.graphql';
import mutationQuery from 'graphql/mutations/supplier/SupplierConfigMutation.graphql';
import fragment from 'graphql/fragments/supplier/SupplierConfigFragment.graphql';
import { ALLOW_EDIT, ALLOW_VIEW } from '../../../utils/OperationPermissions';
import { EntityType } from '../../../@types/entityTypes';

const SupplierConfig: EntityType = {
  type: 'SupplierConfig',
  title: 'Supplier Configuration',
  formTitle: 'Supplier Configuration',
  formUrl: '/Suppliers/SupplierConfig/',
  instance: instanceQuery,
  default: defaultQuery,
  update: mutationQuery,
  fragment,
  screenReference: 'SUPPLIERS_CONFIGURATION',
  operations: ALLOW_EDIT | ALLOW_VIEW,
};

export default SupplierConfig;
